"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var errorCodes_1 = __importDefault(require("./constants/errorCodes"));

var string_1 = require("./string");

var array_1 = require("./array");

var createErrorStructure = function createErrorStructure(_ref) {
  var code = _ref.code,
      status = _ref.status,
      message = _ref.message,
      meta = _ref.meta;
  return {
    errors: [{
      code: code,
      status: status,
      message: message,
      meta: meta
    }]
  };
};

exports.getResponseError = function (response) {
  if (response.data) return response.data;

  if (response.status === 404) {
    return createErrorStructure({
      code: errorCodes_1.default.NOT_FOUND,
      status: response.status
    });
  }

  if (response.status === 504) {
    return createErrorStructure({
      code: errorCodes_1.default.GATEWAY_TIMEOUT,
      status: response.status
    });
  }

  return 'undefined error';
};

exports.responseErrorTransform = function (response) {
  if (!response.ok && !response.error) {
    response.error = exports.getResponseError(response);
  }
};

exports.getErrorMessage = function (responseError, defaultError) {
  var messageErrors = '';
  if (!responseError) return defaultError;

  if (responseError.errors) {
    var errorMessageForConcat = [];
    responseError.errors.map(function (item) {
      return item.message && errorMessageForConcat.push(item.message);
    });
    messageErrors = string_1.concatMessages(errorMessageForConcat);
  }

  return messageErrors && !array_1.isEmpty(messageErrors) ? messageErrors : defaultError;
};

exports.existsErrorCode = function (code, responseError) {
  if (responseError && responseError.errors) {
    for (var index = 0; index < responseError.errors.length; index += 1) {
      if (code === responseError.errors[index].code) {
        return true;
      }
    }
  }

  return false;
};

exports.existsErrorCodes = function (codes, responseData) {
  if (responseData && responseData.errors) {
    for (var index = 0; index < responseData.errors.length; index += 1) {
      if (codes.includes(responseData.errors[index].code)) {
        return true;
      }
    }
  }

  return false;
};

var ERROR_HANDLING_UTILS = {
  getResponseError: exports.getResponseError,
  getErrorMessage: exports.getErrorMessage,
  existsErrorCode: exports.existsErrorCode,
  existsErrorCodes: exports.existsErrorCodes,
  responseErrorTransform: exports.responseErrorTransform
};
exports.default = ERROR_HANDLING_UTILS;